<script setup lang="ts">
  import { defineProps } from 'vue'
  interface IProps {
    type:
      | 'ok'
      | 'buynx'
      | 'buy'
      | 'chargenx'
      | 'confirm'
      | 'confirm'
      | 'myitems'
      | 'prizes'
      | 'tooltip'
      | 'viewcode'
      | 'close'
    isInactive?: boolean
  }
  const props = withDefaults(defineProps<IProps>(), {
    type: 'ok',
    isInactive: false,
  })
</script>

<template>
  <div
    class="marvel-machine-btn"
    :class="`marvel-machine-btn--${props.type} ${props.isInactive ? 'inactive' : ''}`"
  ></div>
</template>

<style lang="scss" scoped>
  %marvelmarvelButtonsub {
    width: 174px;
    height: 65px;
  }
  %marvelButtonMain {
    width: 162px;
    height: 73px;
  }
  .marvel-machine-btn {
    cursor: pointer;
    background: no-repeat center center / 100% auto;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background: no-repeat center center / 100% auto;
    }
    &.inactive {
      cursor: auto;
      background: no-repeat center center / 100% auto;
    }
  }

  .marvel-machine-btn--myitems {
    width: calc(162px * var(--marvel-desktopRatio));
    height: calc(73px * var(--marvel-desktopRatio));
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/myItems/my-items-btn-rest.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/myItems/my-items-btn-hover.png');
    }
    &.inactive {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/myItems/my-items-btn-disabled.png');
    }
  }

  .marvel-machine-btn--prizes {
    width: calc(162px * var(--marvel-desktopRatio));
    height: calc(73px * var(--marvel-desktopRatio));
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/prizes/prizes-btn-rest.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/prizes/prizes-btn-hover.png');
    }
    &.inactive {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/prizes/prizes-btn-disabled.png');
    }
  }

  .marvel-machine-btn--ok {
    @extend %marvelButtonMain;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/ok/ok-btn-v1.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/ok/ok-btn-hover.png');
    }
  }

  .marvel-machine-btn--close {
    @extend %marvelButtonMain;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/close/close-btn.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/close/close-btn-hover.png');
    }
  }

  .marvel-machine-btn--chargenx {
    width: 110px;
    height: 42px;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/chargeNx/charge-nx-btn.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/chargeNx/charge-nx-btn-hover.png');
    }
  }

  .marvel-machine-btn--buynx {
    @extend %marvelButtonMain;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/buyNx/buynx-btn.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/buyNx/buynx-btn-hover.png');
    }
  }

  .marvel-machine-btn--buy {
    @extend %marvelButtonMain;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/buy/buy-btn.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/buy/buy-btn-hover.png');
    }
    &.inactive {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/buy/buy-btn-disabled.png');
    }
  }

  .marvel-machine-btn--tooltip {
    width: calc(92px * var(--marvel-desktopRatio));
    height: calc(92px * var(--marvel-desktopRatio));
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/tooltip/more-info-btn-rest.png');
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/tooltip/more-info-btn-hover.png');
    }
  }

  .marvel-machine-btn--viewcode {
    width: 31vw;
    height: 17vw;
    background-image: url('@/assets/imgs/mavelmachine/marvelButtons/viewCode/view-code-btn-default.png');
    display: none;
    &:hover,
    &:after {
      background-image: url('@/assets/imgs/mavelmachine/marvelButtons/viewCode/view-code-btn-default.png');
    }
  }

  /* @media #{$tabletForMarvel} {
  .marvel-machine-btn--tooltip {
    width: 6vw;
    height: 6vw;
  }
} */
  @media #{$mobileForMarvel} {
    .marvel-machine-btn--viewcode {
      display: inline-block;
    }
    .marvel-machine-btn--myitems,
    .marvel-machine-btn--prizes {
      width: 22vw;
      height: 10vw;
    }
    .marvel-machine-btn--tooltip {
      width: 9vw;
      height: 9vw;
    }
  }
</style>
